import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles, BookOpen, Smartphone } from "lucide-react";

/**
 * Sticky mobile action bar for the LANDING page only.
 *
 * The landing is a long marketing scroll. Instead of forcing visitors to
 * reach the bottom to take an action, we anchor a thumb-reachable three-slot
 * bar at the bottom of the viewport on mobile: Guidance · Install · Chart.
 *
 * Hidden on ≥ md so it doesn't clutter desktop.
 */
export default function LandingActionBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Reveal only after user has scrolled past the hero (feels less pushy)
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="landing-action-bar"
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-[color:var(--gold)]/25 backdrop-blur-xl transform ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      style={{
        background: "rgba(5, 9, 23, 0.94)",
        paddingBottom: "env(safe-area-inset-bottom)",
        transition: "transform 350ms cubic-bezier(0.25, 0.8, 0.25, 1)",
      }}
    >
      <div className="grid grid-cols-3 gap-1 p-2">
        <Link
          to="/almanac"
          data-testid="landing-cta-almanac"
          className="flex flex-col items-center justify-center py-2 rounded-xl text-[color:var(--parchment-soft)] hover:bg-[color:var(--gold)]/10"
        >
          <BookOpen size={18} className="text-[color:var(--gold)]" />
          <span className="text-[10px] mt-1 tracking-wide font-sans-body">Today</span>
        </Link>
        <a
          href="#install-app"
          data-testid="landing-cta-install"
          className="flex flex-col items-center justify-center py-2 rounded-xl text-[color:var(--parchment-soft)] hover:bg-[color:var(--gold)]/10"
        >
          <Smartphone size={18} className="text-[color:var(--gold)]" />
          <span className="text-[10px] mt-1 tracking-wide font-sans-body">Install</span>
        </a>
        <Link
          to="/subscribe"
          data-testid="landing-cta-chart"
          className="flex flex-col items-center justify-center py-2 rounded-xl bg-[color:var(--gold)] text-[color:var(--bg-base)] font-medium"
        >
          <Sparkles size={18} />
          <span className="text-[10px] mt-1 tracking-wide font-sans-body">£8.88 / mo</span>
        </Link>
      </div>
    </div>
  );
}
